<template>
	<div>
		<div class="timer-container">
			<svg class="timer-svg" viewBox="0 0 100 100">
				<g class="timer-circle">
					<circle class="timer-path-elapsed" cx="50" cy="50" r="45" />
					<path
						:stroke-dasharray="circleDasharray"
						class="timer-path-remaining"
						d="M 50, 50 m -45, 0 a 45,45 0 1,0 90,0 a 45,45 0 1,0 -90,0"
					/>
				</g>
			</svg>
			<button @click.prevent="togglePlay">
				<SVGIcon
					:icon-name="playPauseIcons"
					width="30px"
					height="30px"
					class="play-pause-icons mr-10 pointer flex-center"
				/>
			</button>
			<audio ref="audioEl" :src="url" />
		</div>
	</div>
</template>

<script>
import SVGIcon from '~/components/interface/SVGIcon'

export default {
	name: 'SoundPlayer',
	components: { SVGIcon },
	props: {
		url: {
			type: String,
			default: ''
		}
	},
	data: () => ({
		play: false,
		timeLimit: 10,
		timePassed: 0,
		timerInterval: null,
		fullDashArray: 283
	}),
	computed: {
		playPauseIcons () {
			return this.play ? 'pause-button' : 'play-button'
		},

		circleDasharray () {
			return `${(this.timeFraction * this.fullDashArray).toFixed(0)} 283`
		},

		timeLeft () {
			return this.timeLimit - this.timePassed
		},

		timeFraction () {
			const rawTimeFraction = this.timeLeft / this.timeLimit
			return rawTimeFraction - (1 / this.timeLimit) * (1 - rawTimeFraction)
		}
	},
	watch: {
		url: {
			handler () {
				if (this.play) {
					this.togglePlay()
				}
				this.timePassed = 0
				this.timerInterval = null
			}
		},
		timePassed: {
			handler (value) {
				if (value >= this.timeLimit) {
					this.togglePlay()
					this.$refs.audioEl.currentTime = 0
					this.timePassed = 0
					this.timerInterval = null
				}
			}
		},
		timeLeft (newValue) {
			if (newValue === 0) {
				this.onTimesUp()
			}
		}
	},
	methods: {
		togglePlay () {
			const audio = this.$refs.audioEl

			this.play = !this.play

			if (audio.paused && this.play) {
				audio.play()
				this.startTimer()
			} else {
				audio.pause()
				this.onTimesUp()
			}
		},

		onTimesUp () {
			clearInterval(this.timerInterval)
		},

		startTimer () {
			this.timerInterval = setInterval(() => (this.timePassed += 1), 1000)
		}
	}
}
</script>

<style lang="scss">
.timer-container {
	position: relative;
	width: 30px;
	height: 30px;
	.timer-svg {
		transform: scaleX(-1);
	}
	.timer-circle {
		fill: none;
		stroke: none;
	}
	.timer-path-elapsed {
		stroke-width: 7px;
		stroke: grey;
	}
	.timer-path-remaining {
		stroke-width: 7px;
		stroke-linecap: round;
		transform: rotate(90deg);
		transform-origin: center;
		transition: 1s linear all;
		fill-rule: nonzero;
		stroke: currentColor;
		color: white;
	}
	.play-pause-icons {
		position: absolute;
		top: 0;
		left: 0;
	}
}
</style>
